export const CustomisationPreviewFormControlKind = {
  FreeText: 'free-text',
  FreeImage: 'free-image',
} as const;

export type CustomisationPreviewFormControlKind =
  (typeof CustomisationPreviewFormControlKind)[keyof typeof CustomisationPreviewFormControlKind];

export const CustomisationPreviewFormFieldMetaKey = 'customisationPreview' as const;

export type CustomisationPreviewFormFieldMeta<TRole extends string = string> = {
  controlKind: CustomisationPreviewFormControlKind;
  role: TRole;
};
